import { useCustomProp } from '@common/components/LibraryComponent/customProp';
import Loading from '@common/components/Loading';
import { defaultPathComponent } from '@common/constants/shared';
import {
  setDefaultValueInput,
  setValueInput,
} from '@common/redux/slice/formInputs';
import { ILibraryComponent } from '@common/types/element';
import { getValueBindingComponent } from '@common/utils/component';
import { normalizeComponentName } from '@common/utils/componentName';
import { get } from 'lodash';
import React, { FC, useCallback, useMemo } from 'react';
import { View } from 'react-native';
import { useDispatch } from 'react-redux';
const libraries = require('@appos/components');

import createStyles from './style';

declare global {
  interface Window {
    [key: string]: any;
  }
}

/** @appos/components exports PascalCase (Button, CardList); attributes.componentName may be camelCase (button, cardList) */
const toPascalCase = (s: string) =>
  s ? s.charAt(0).toUpperCase() + s.slice(1) : s;

const CusLibraryComponent: FC<ILibraryComponent> = (attributes) => {
  const pascalName = toPascalCase(
    normalizeComponentName(attributes.componentName ?? '')
  );
  const Component =
    libraries[pascalName] ?? libraries[attributes.componentName];

  const styles = createStyles(attributes);
  const { getCustomProp, loading } = useCustomProp(attributes);
  const dispatch = useDispatch();

  const valueInputs = useMemo(
    () => get(attributes, `dependencies.valueInputs.${attributes.id}`, false),
    [attributes.dependencies, attributes.id]
  );

  const changeInput = useCallback(
    (value: any) => {
      dispatch(
        setValueInput({
          [attributes.id]: value,
        })
      );
    },
    [attributes.id]
  );

  const setDefaultValue = useCallback(
    (value: any) => {
      dispatch(
        setDefaultValueInput({
          [attributes.id]: value,
        })
      );
    },
    [attributes.id]
  );

  if (loading) {
    return <Loading />;
  }

  if (!Component) return <></>;

  return (
    <View style={styles.container}>
      <Component
        {...attributes}
        {...getCustomProp()}
        valueInputs={valueInputs}
        changeInput={changeInput}
        setDefaultValue={setDefaultValue}
      >
        {attributes?.children}
      </Component>
    </View>
  );
};

export default CusLibraryComponent;
